module.exports = __webpack_public_path__ + "static/media/0003.f41bbed5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48104/Decors_colored/N02_black/0003.png
// module id = 2223
// module chunks = 0